import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ThemeToggle } from '@/components/marketing/theme-toggle';

export function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <p className="font-display text-7xl font-light text-zinc-500 dark:text-zinc-400 mb-2">404</p>
      <h2 className="text-lg font-semibold text-zinc-900 dark:text-zinc-100 mb-2">Page not found</h2>
      <p className="text-sm text-zinc-500 dark:text-zinc-400 mb-6">The page you're looking for doesn't exist or has been moved.</p>
      <Link to="/dashboard">
        <Button size="sm">Back to Dashboard</Button>
      </Link>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-white dark:bg-zinc-950 flex flex-col">
      <header className="flex items-center justify-between px-6 py-3.5 bg-white dark:bg-zinc-950 border-b border-zinc-200 dark:border-zinc-800">
        <Link to="/" className="flex items-center gap-2.5">
          <img width={24} height={24} src="/assets/logo_square.svg" alt="Kora" className="w-6 h-6 dark:invert" />
          <span className="font-semibold text-sm tracking-tight text-zinc-900 dark:text-zinc-100">Kora</span>
        </Link>
        <ThemeToggle />
      </header>
      <div className="flex-1 flex flex-col items-center justify-center text-center px-4">
        <p className="text-7xl font-bold text-zinc-200 dark:text-zinc-800 mb-3">404</p>
        <h2 className="text-xl font-semibold text-zinc-900 dark:text-zinc-100 mb-2">Page not found</h2>
        <p className="text-sm text-zinc-500 dark:text-zinc-400 mb-8 max-w-sm">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/">
          <Button size="sm">Back to Home</Button>
        </Link>
      </div>
    </div>
  );
}
